import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { SidebarCollapsingNavList, SidebarCollapsingNavListItem } from '@src/components/sco/SidebarCollpasingNavList';
import React from 'react';
import { LuCalendar, LuSquareCheck, LuClock, LuHammer, LuPhoneCall, LuUsers, LuPresentation } from 'react-icons/lu';
type EventsNavProps = {};
const eventsNavSections: SidebarCollapsingNavListItem[] = [{
  title: 'Upcoming Events',
  icon: () => <LuCalendar />,
  href: `/events`,
  activeExact: true
}, {
  title: 'My Events',
  icon: () => <LuSquareCheck />,
  href: `/events/my-events`,
  activeExact: true
}, {
  title: 'Workshops',
  icon: () => <LuHammer />,
  href: `/events/workshops`,
  activeExact: true
}, {
  title: 'Group Meetings',
  icon: () => <LuUsers />,
  href: `/events/group-meetings`,
  activeExact: true
}, {
  title: 'Office Hours',
  icon: () => <LuPhoneCall />,
  href: `/events/office-hours`,
  activeExact: true
}, {
  title: 'Public Events',
  icon: () => <LuPresentation />,
  href: '/events/public',
  activeExact: true
}, {
  title: 'Past Events',
  icon: () => <LuClock />,
  href: `/events/past`,
  activeExact: true
}];
export const EventsNav = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VStack align="stretch" height="full" justify="stretch" width="full"><SidebarCollapsingNavList collapsed={false} defaultTitle="Events" items={eventsNavSections} /><Box flexGrow={1} /></VStack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};